import { useEffect, useState } from "react";
import api from "../../lib/api";
import ProductCard from "../ProductCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FeaturedProducts() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { featured: true, limit: 8 } }).then((r) => {
      setProducts(r.data.items || []);
    }).catch(() => {});
  }, []);

  if (!products.length) return null;

  return (
    <section className="section-pad bg-softbg" data-testid="featured-products">
      <div className="container-site">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <div>
            <p className="accent-script text-gold text-2xl mb-1">Öne Çıkan</p>
            <h2 className="heading-serif text-3xl md:text-4xl font-semibold text-navy">
              Danışmanlarımızın Seçimi
            </h2>
            <p className="text-gray-600 mt-2 max-w-xl">
              5 yıldız standartlarında, uzman ekibimizin projelerde sıkça tercih ettiği ekipmanlar.
            </p>
          </div>
          <Link to="/kategoriler" className="text-navy hover:text-gold flex items-center gap-1 link-underline">
            Tüm Ürünler <ArrowRight size={14} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
    </section>
  );
}
